import { render } from "./index.vue?vue&type=template&id=ffa120c6"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
script.render = render

export default script